import { render, staticRenderFns } from "./globe.vue?vue&type=template&id=7f229862"
import script from "./globe.vue?vue&type=script&lang=js"
export * from "./globe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports